const HisLayers = ({ color, sx }) => {
  const strokeColor = color ?? "#708FBB";
  const _sx = sx ?? {};
  return (
    <svg
      style={_sx}
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5 1L1 8.25L15.5 15.5L30 8.25L15.5 1Z"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 22.75L15.5 30L30 22.75"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 15.5L15.5 22.75L30 15.5"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HisLayers;
